import React, { useCallback } from 'react';
import { useAuthorization } from 'framework/authorization';
import { SaveFormShowButton, CloseFormShowButton, EditFormShowButton, useFormShowContext } from 'framework/form';
import { VENDOR_UPDATE, VENDOR_UPDATE_PRIVILEGED_INFO } from '../constants';
import { Box } from '@mui/material';
import { Stack } from '@mui/material';
import EditVendorProfile from '../createupdate/Update/EditVendorProfile';
import ShowVendorProfile from './ShowVendorProfile';

const VendorProfileLayout = () => {
  const { isGranted } = useAuthorization();
  const { isEditMode } = useFormShowContext();

  const renderActionButtons = useCallback(() => {
    if (isGranted(VENDOR_UPDATE) || isGranted(VENDOR_UPDATE_PRIVILEGED_INFO)) {
      return isEditMode ? (
        <>
          <SaveFormShowButton />
          <CloseFormShowButton />
        </>
      ) : (
        <EditFormShowButton />
      );
    }

    return null;
  }, [isEditMode, isGranted]);

  return (
    <Box position="relative">
      <Box
        sx={{
          position: 'absolute',
          display: 'flex',
          justifyContent: 'flex-end',
          top: '-8px',
          right: '-8px',
          zIndex: 1,
        }}
      >
        {renderActionButtons()}
      </Box>

      <Stack>{isEditMode ? <EditVendorProfile /> : <ShowVendorProfile />}</Stack>
    </Box>
  );
};

export default VendorProfileLayout;
